import HARDCODE from '../../../business-const/HardCode/HardCode'



const statusGrupoConsorcioList = (listaCompleta) => {

    const statusGrupoConsorcioListAux = [
        {
            id: 'E',
            descricao: 'Em Andamento',
            ordem: 10,
        },
        {
            id: 'N',
            descricao: 'Novo',
            ordem: 20,
        },
    ]

    if (listaCompleta) {

        statusGrupoConsorcioListAux.push(
            {
                id: HARDCODE.idStatusGrupoConsorcioNaoInformado,
                descricao: 'Não Informado',
                ordem: 30,
            },
        )
    }

    return statusGrupoConsorcioListAux
}

export default statusGrupoConsorcioList